module.exports = __webpack_public_path__ + "img/logo-bouygues-telecom-entreprises-white.c19fa74a.png";